(function () {
    'use strict';

    angular
        .module('app')
        .controller('WorkflowDefinitionSelectorDialogCtrl', WorkflowDefinitionSelectorDialogCtrl);

    WorkflowDefinitionSelectorDialogCtrl.$inject = ['WorkflowService', 'DialogService', 'DialogInstance'];

    /**
     * Dialog for selecting a workflow definition.
     * Returns a workflow definition object in the dialog resolve.
     */
    function WorkflowDefinitionSelectorDialogCtrl(WorkflowService, DialogService, DialogInstance) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.workflowDefinitions = [];
        vm.selectedWorkflowDefinition = null;
        vm.loading = true;

        activate();

        function activate() {
            WorkflowService.query({ active: true }).then(
                function ok(data) {
                    vm.workflowDefinitions = data.Items;
                    vm.loading = false;
                }, function error(response) {
                    DialogService.error('Error fetching Workflow definitions', response);
                    DialogInstance.cancel();
                });
        }

        function ok() {
            DialogInstance.ok(vm.selectedWorkflowDefinition);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();